const EXPIRY_WARNING_DAYS = 7;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const getExpirationDate = (lockedDate?: string): number | undefined => {
  const expireDate = lockedDate ? new Date(lockedDate) : null;

  if (!expireDate || isNaN(expireDate.getTime())) {
    return undefined;
  }

  const daysRemaining = Math.ceil((expireDate.getTime() - Date.now()) / MS_PER_DAY);

  return daysRemaining >= 0 && daysRemaining <= EXPIRY_WARNING_DAYS ? daysRemaining : undefined;
};
